import ClassroomService from "../services/ClassroomService";
import StoreRepository from "../repositories/StoreRepository";
import ComparatorService from "../services/ComparatorService";
export default class ClassroomManager {
    constructor(occasionManager) {
        this._classroomService = new ClassroomService();
        this._classroomRepository = new StoreRepository();
        this._compareService = new ComparatorService();
        let occasionStore = occasionManager.occasionRepository.getStore();
        let id = 0;
        Object.keys(occasionStore).forEach(key => {
            let classroom = this._classroomService.mapInterfaceToModel({
                id: occasionStore[key].classroom !== null ? occasionStore[key].classroom : "0",
                name: occasionStore[key].classroom
            });
            this._classroomRepository.storeItem(classroom);
        });
    }
    getClassrooms() {
        let store = this._classroomRepository.getStore();
        let array = [];
        Object.keys(store).forEach(key => {
            array.push(store[key]);
        });
        return array;
    }
    getClassroomSorted() {
        return this.getClassrooms().sort(this._compareService.compareByName);
    }
    get classroomService() {
        return this._classroomService;
    }
    set classroomService(value) {
        this._classroomService = value;
    }
    get classroomRepository() {
        return this._classroomRepository;
    }
    set classroomRepository(value) {
        this._classroomRepository = value;
    }
}
